import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import Negocio from '../../../functions/logic/Negocio'
import DynamicTable from '../../../components/DataTables/DynamicTable'
import Spiner from '../../../components/Spiner'
import FormModal from '../../../components/General/FormModal'
import ConfirmModal from '../../../components/ConfirmModal'
import { useSnackbar } from 'notistack'

export default function EnvioSeguimiento() {
    const [spiner, setSpiner] = useState(false)
    const [isOpenModalform, setIsOpenModalForm] = useState(false)
    const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false)
    const [dataServiceForm, setDataServiceForm] = useState([])
    const [orderId, setOrderId] = useState(0)
    const [saveType, setSaveType] = useState('I')
    const [ordenId, setOrdenId] = useState(0)
    const [headerModal, setheaderModal] = useState('I')
    const param = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const userToken = localStorage.getItem('userToken')
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)

    const columns = ['Orden', 'Fecha', 'Subtotal', 'Subtotal2', 'Descuento', 'Envio', 'Iva', 'Total', 'Estado orden', 'Estado Pago']

    const getOrdenesPendientesEnvio = useCallback(async (page, perPage, param, ordenId, search) => {
        setSpiner(true)
        global.MENU_MODULE_SELECT = 'negocio'
        const response = await Negocio.getOrdenesPendientesEnvioLogic(page, perPage, userToken, param.moduleId, ordenId, search)
        localStorage.setItem('param', JSON.stringify(param.moduleId))
        if (!response.error) {
            setdata(response["responseTableMapper"])
            setTotalRows(response.total_records)
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setSpiner(false)
    }, [enqueueSnackbar, userToken]) 

    useEffect(() => {
        getOrdenesPendientesEnvio(1, 5, param, 0, 'no')
    }, [param, getOrdenesPendientesEnvio])

    const handleEdit = async (orden) => {
        setSpiner(true)
        setheaderModal("Detalle de la orden")
        setSaveType("E")
        setOrdenId(orden.id)
        const response = await Negocio.getOrdenesPendientesEnvioLogic(1, 1, userToken, param.moduleId, orden.id, 'no')
        if (response.orden) {
            setDataServiceForm(response.orden)
        }
        setIsOpenModalForm(true)
        setSpiner(false)
    }
    

    const handledSave = async (event) => {
        setSpiner(true)
        event.preventDefault()
        enqueueSnackbar('Datos actualizados', {
            variant: 'success',
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setSpiner(false)
    }

    const handleCloseModal = () => {
        setIsOpenModalForm(false)
        setIsOpenModalConfirm(false)
        cleanStorage()
    }

    const cleanStorage = () => {
        localStorage.removeItem('nombre')
        localStorage.removeItem('ubicacion')
        localStorage.removeItem('tipo')
        localStorage.removeItem('estado')
        localStorage.removeItem('codigo')
    }

    const handlePageChange = (page, perPage) => {
        setSpiner(true)
        getOrdenesPendientesEnvio(page, perPage, param, 0, 'no')
        setSpiner(false)
    }

    const handleSearch = (item) => {
        alert(item)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <FormModal
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={headerModal}
                button={'Guardar'}
                formData={dataServiceForm}
                handledSave={handledSave}
                opt={'envioSeguimiento'}
                modalWith={'xl'}
            />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="project-actions text-right">
                                           <h4>Ordenes pendientes de envío</h4>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <DynamicTable
                                                columns={columns}
                                                data={data}
                                                headerText=""
                                                onEdit={handleEdit}
                                                onSearch={handleSearch}
                                                onPageChange={handlePageChange}
                                                totalRows={totalRows}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </>
    )
}




